export default "__VITE_ASSET__Uud5vqRX__"